import React from "react";
import { DeletePopUp } from "../../../../components/PopUp";
import { getNumberFormat } from "../../../../utils";
import { DeletePaymentModalProps } from "./types";

export const DeletePaymentModal: React.FC<DeletePaymentModalProps> = React.memo(
  ({
    isOpen,
    paymentAmount,
    onClose,
    onDelete,
    isDeleting = false,
    deleteError,
  }) => {
    return (
      <DeletePopUp
        isOpen={isOpen}
        setIsOpen={onClose}
        title="Delete Payment Liability"
        text={
          <>
            Do you really want to delete the{" "}
            <strong>{getNumberFormat(Number(paymentAmount))}€</strong> payment?
          </>
        }
        handleOnDelete={onDelete}
        isLoading={isDeleting}
        errorMessage={deleteError}
      />
    );
  },
);

DeletePaymentModal.displayName = "DeletePaymentModal";
